// extracted by mini-css-extract-plugin
export var divider = "_v1-0";